module.exports = __webpack_public_path__ + "img/super-draw-past.fcfb62dc.webp";